import { EventType } from 'types';
import { WeekdayType } from 'utils/weekdays';

import { getRanges } from './components/DateRangePicker/presets';

interface ClassUsageSearchFilters {
  period: string;
  startDate: Date | null;
  endDate: Date | null;
  classTypes: EventType[];
  coachIds: string[];
  weekdays: WeekdayType['day'][];
  classStartTimeFrom: string | null;
  classStartTimeTo: string | null;
  groupByClass: boolean;
  groupByDay: boolean;
  groupByStartTime: boolean;
  groupByCoach: boolean;
}

const initialSearchFilters: ClassUsageSearchFilters = {
  period: 'last_week',
  startDate: getRanges('last_week')[0],
  endDate: getRanges('last_week')[1],
  classTypes: [],
  coachIds: [],
  weekdays: [],
  classStartTimeFrom: null,
  classStartTimeTo: null,
  groupByClass: true,
  groupByDay: false,
  groupByStartTime: true,
  groupByCoach: true,
};

export { initialSearchFilters, type ClassUsageSearchFilters };
